import { compareHelpers, mathService } from '@approvalmax/utils';
import { backend, domain } from 'modules/data';
import { mapAttachment } from 'modules/data/domain/schemas/requestSchema';
import { PayNetworkType } from 'shared/data/wallets/v1';
import { AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource } from 'shared/data/webApp/v2';

import { PaymentSource } from './XeroAmaxPayBatchPaymentForm.types';

export const checkPaymentDetailsHasConflictingVersions = (items: domain.AmaxPayPaymentItem[]) => {
    const paymentDetailsWithVersions: Record<string, string> = {};

    return items.some((item) => {
        if (!item.contact?.id || !item.paymentDetails) return false;

        if (!paymentDetailsWithVersions[item.paymentDetails.id]) {
            paymentDetailsWithVersions[item.paymentDetails.id] = item.paymentDetails.versionId;

            return false;
        }

        return paymentDetailsWithVersions[item.paymentDetails.id] !== item.paymentDetails.versionId;
    });
};

export const mapAmaxPayXeroBillInvoiceRequests = (
    requests: backend.XeroAmaxPayBillInvoiceRequest[]
): domain.AmaxPayBatchSelectableBillItem[] => {
    return requests.map((request) => {
        return {
            id: request.xeroBillInvoiceRequestId,
            currency: request.currency,
            plannedDate: request.plannedDate,
            xeroBillInvoiceRequestId: request.xeroBillInvoiceRequestId,
            orderNumber: 0,
            friendlyName: request.friendlyName,
            date: request.date,
            dueDate: request.dueDate,
            scheduledDate: undefined,
            amountDue: request.amountDue,
            note: request.note,
            contact: {
                id: request.contact.id,
                text: request.contact.name,
                defaultReference: request.reference || request.details || '',
            },
            amaxPayBankAccount: request.amaxPayBankAccount,
            paymentChargeType: request.paymentChargeType,
            paymentDetails: request.defaultPaymentDetails,
            selected: false,
            details: request.details,
            amountOnApproval: request.amountOnApproval || 0,
            amountInProcessing: request.amountInProcessing || 0,
            amountAwaitingPayment: request.amountAwaitingPayment || 0,
            amountOnReview: request.amountOnReview || 0,
            amount: mathService.subtract(
                request.amountDue,
                mathService.add(
                    mathService.add(request.amountInProcessing || 0, request.amountOnApproval || 0),
                    request.amountAwaitingPayment || 0
                )
            ),
            reference: request.reference,
            code: request.code,
            particulars: request.particulars,
            xeroBillInvoiceReference: request.xeroBillInvoiceReference,
            defaultBankAccount: request.bankAccountNumber || null,
            attachments: (request.attachments || [])
                .map(mapAttachment)
                .sort(
                    compareHelpers.comparatorFor<domain.RequestAttachment>(compareHelpers.stringComparator2Asc, 'name')
                ),
            outstandingBalance: request.outstandingBalance,
            overdueBalance: request.overdueBalance,
            paymentReference: request.reference || request.details || request.xeroBillInvoiceReference || '',
            bankAccount: null,
            paymentFee: null,
        };
    });
};

/**
 * @todo get rid of `toLowerCase` after BE will provide `payNetworkType` field within PaymentDetails object
 */
export const isSwiftPaymentMethod = (paymentMethod: string | undefined) => {
    return paymentMethod?.toLowerCase() === PayNetworkType.swift;
};

export const isWalletsPaymentSource = (paymentSource: PaymentSource | undefined) => {
    return paymentSource?.id === AmaxPayXeroDomainEntitiesApprovalEntitiesPaymentSource.virtual_account;
};
